import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Componente DescriptionItemsService
 *
 * Este componente é usado para exibir informações descritivas de um serviço,
 * incluindo título, descrição e preço.
 *
 * **Como usar:**
 *
 * ```html
 * <app-ui-description-items-service
 *   [title]="'Título do Serviço'"
 *   [description]="'Descrição detalhada do serviço'"
 *   [label]="'Preço do serviço aqui'"
 * ></app-ui-description-items-service>
 * ```
 *
 * **Propriedades (Inputs):**
 * - `title` (string, obrigatório): Define o título do serviço.
 * - `description` (string, opcional): Define a descrição detalhada do serviço.
 * - `label` (string, opcional): Define o preço ou detalhes do custo do serviço.
 **/

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-description-items-service',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './description-items-service.component.html',
  styleUrls: ['./description-items-service.component.scss'],
})
export class DescriptionItemsServiceComponent {
  title = input.required();
  description = input();
  label = input();
  subtitleColor = input<string>();
}
